import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  GET_CUSTOMERS: "api/CRM/Leads",
  GET_TAGS: "api/CRM/Tags",
  OPPORTUNITY: "api/CRM/Opportunity",
  GET_OPPORTUNITY_STATUS: "api/CRM/OpportunitiesByStatus",
  UPDATE_OPPORTUNITY_STATUS: "api/CRM/ChangeOpportunitiesStatus",
  GET_CUSTOMER_STATUS: "api/CRM/LeadStatus",
  GET_MASTER_PRODUCTS: "api/CRM/MasterProducts",
  GET_OPPORTUNITY_LOST_REASON: "api/CRM/OpportunityReasons",
  GET_OPPORTUNITIES: "api/CRM/Opportunities",
  GET_OPPORTUNITY_SETTING: "api/CRM/OpportunitySetting",
  GET_CUTOMER_OPPORTUNITIES: "api/CRM/Lead/Opportunities",
  GET_VISIT_PURPOSES: "api/CRM/VisitPurposes",
  GET_LEAD_TRANSACTION: "api/CRM/v1/LeadTransaction",
};

const getCustomers = async (data: any): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.post<ApiResponse<any[]>>(
    ENDPOINTS.GET_CUSTOMERS,
    data
  );
  return res.data;
};

const getTagList = async (tagTypeId: number): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(
    `${ENDPOINTS.GET_TAGS}?tagTypeId=${tagTypeId}`
  );
  return res.data;
};

const addOpportunity = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.OPPORTUNITY,
    data
  );
  return res.data;
};

const updateOpportunity = async (
  id: number,
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.OPPORTUNITY}/${id}`,
    data
  );
  return res.data;
};

const deleteOpportunity = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.OPPORTUNITY}/${id}`
  );
  return res.data;
};

const getOpportunitiesByStatus = async (
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.GET_OPPORTUNITY_STATUS}?AssignedToUserIds=${data.AssignedToUserIds}&FromDate=${data.FromDate}&LeadIds=${data.LeadIds}&TagIds=${data.TagIds}&ToDate=${data.ToDate}&dateType=${data.DateType}`
  );
  return res.data;
};

const getVisitData = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.GET_OPPORTUNITIES}/${id}`
  );
  return res.data;
};

const updateMultipleOpportunitiesStatus = async (
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.GET_OPPORTUNITY_STATUS,
    data
  );
  return res.data;
};

const getCustomerStatus = async (): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.GET_CUSTOMER_STATUS
  );
  return res.data;
};

const getMasterProducts = async (data: any): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(
    `${ENDPOINTS.GET_MASTER_PRODUCTS}?From=${data.from}&Text=${data.text}&To=${data.to}`
  );
  return res.data;
};

const getOpportunityLostReason = async (): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(
    ENDPOINTS.GET_OPPORTUNITY_LOST_REASON
  );
  return res.data;
};

const createLostReason = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.OPPORTUNITY,
    data
  );
  return res.data;
};

const getOpportunitySetting = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.GET_OPPORTUNITY_SETTING
  );
  return res.data;
};

const getOpportunitiesByLeadId = async (
  leadId: number
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.GET_CUTOMER_OPPORTUNITIES}/${leadId}`
  );
  return res.data;
};

const getVisitPurposes = async (): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.GET_VISIT_PURPOSES
  );
  return res.data;
};

const getLeadTransaction = async (data: any): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.GET_LEAD_TRANSACTION,
    data
  );
  return res.data;
};

const DealAndPipelineService = {
  getCustomers,
  getTagList,
  addOpportunity,
  updateOpportunity,
  deleteOpportunity,
  getOpportunitiesByStatus,
  getVisitData,
  updateMultipleOpportunitiesStatus,
  getCustomerStatus,
  getMasterProducts,
  getOpportunityLostReason,
  createLostReason,
  getOpportunitySetting,
  getOpportunitiesByLeadId,
  getVisitPurposes,
  getLeadTransaction,
};

export default DealAndPipelineService;
